<template>
  <div class="journey-loading">
    <div class="loading-header">
      <i class="character"></i>
      <div class="loading--wrap">
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
      </div>
      {{ $t('common.loadingDot') }}
    </div>
    <div class="loading-body">
      <span class="tip">Tip!</span>
      <div class="loading-content"
           :class="[`page${pageNumber}`, $i18n.locale]">
        <div v-if="pageNumber < 8"
              class="loading-content-wrap">
          <h4 class="title"
              v-html="$t(`journey.loading.page${pageNumber}.title`)"></h4>
          <div class="image"></div>
          <div class="text">
            <p v-html="$t(`journey.loading.page${pageNumber}.description`)"></p>
          </div>
        </div>
        <div v-else-if="pageNumber === 8"
              class="loading-content-wrap">
          <h4 class="title"
              v-html="$t(`journey.loading.page8.title`)"></h4>
          <div class="image"></div>
        </div>
        <div v-else-if="pageNumber === 9"
              class="loading-content-wrap">
          <h4 class="title"
              v-html="$t(`journey.loading.page9.title`)"></h4>
          <div class="image"></div>
          <div class="text">
            <i class="icon icon--logo-beu"></i>
            <p v-html="$t(`journey.loading.page9.description`)"></p>
            <button @click="openBeusable"
                    v-html="$t(`journey.loading.page9.button`)"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { openBeusable } from '@/libs/utils'

import { mapState } from 'vuex'
import { format } from 'date-fns'

export default {
  name: 'JourneyLoading',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'apiCancelSource',
      'journeyPeriod',
      'journeyOptions'
    ]),
    pageNumber () {
      return Math.floor(Math.random() * 9) + 1
    },
    reportView () {
      return this.$route.name
    },
    isEndDateNotToday () {
      if (this.journeyPeriod.end === format(new Date(), 'YYYY-MM-DD')) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    openBeusable () {
      openBeusable()
    }
  }
}
</script>

<style lang="scss" scoped>
.journey-loading {
  width: 600px;
  height: 600px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  .loading-header {
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    color: #ec0047;

    .character {
      width: 109px;
      height: 111px;
      display: block;
      margin: 46px auto 20px;
      background-image: url(../../assets/img/journey/loading-character.svg?url);
      background-size: 100% 100%;
      background-position: center;
    }

    .loading--wrap {
      width: 180px;
      height: 12px;
      margin: 20px auto 17px;

      .loading-bar {
        display: block;
        position: absolute;
        padding: 6px;
        border-radius: 50%;
        background-color: $brandColor;
        animation: loading 1.4s ease-in-out 0s infinite;

        &:nth-child(1) {
          animation-delay: 0s;
        }

        &:nth-child(2) {
          animation-delay: 0.15s;
        }

        &:nth-child(3) {
          animation-delay: 0.3s;
        }

        &:nth-child(4) {
          animation-delay: 0.45s;
        }

        &:nth-child(5) {
          animation-delay: 0.6s;
        }
      }
    }
  }

  .loading-body {
    width: 550px;
    height: 328px;
    border-radius: 6px;
    background-color: #1b1b1d;
    margin: 25px 25px 12px 25px;
    position: relative;

    .tip {
      font-size: 12px;
      color: #ffffff;
      border-radius: 2px;
      background-color: #43b6c9;
      padding: 4px 6px;
      position: absolute;
      top: 6px;
      left: 6px;
    }

    .loading-content {
      position: relative;
      height: 100%;

      .loading-content-wrap {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 100%;
        box-sizing: border-box;
      }

      .title {
        font-size: 18px;
        line-height: 1.33;
        color: #ffcf00;
        text-align: center;
      }

      .image {
        margin: 0 auto;
        background-size: contain;
        border-radius: 5px;
      }

      .text {
        p {
          font-size: 14px;
          line-height: 1.57;
          text-align: center;
          color: #bbbbbb;
        }

        button {
          float: right;
          vertical-align: middle;
          padding: 6px 19px;
          color: #ffffff;
          font-size: 13px;
          border-radius: 20px;
          border: solid 1px #888888;
          margin-top: -5px;
          background-color: rgba(255, 255, 255, 0);
          transition: background-color 0.15s ease;

          &:hover {
            background-color: rgba(255, 255, 255, 0.1);
          }

          &:active {
            background-color: rgba(255, 255, 255, 0.5);
          }
        }
      }

      &.page1 {
        .image {
          width: 232px;
          height: 100px;
          margin: 28px auto 22px;
          background-image: url(../../assets/img/journey/loading/img-01.svg?url);
        }
      }

      &.page2 {
        .image {
          width: 235px;
          height: 100px;
          margin: 28px auto 22px;
          background-image: url(../../assets/img/journey/loading/img-02.svg?url);
        }
      }

      &.page3 {
        .image {
          width: 297px;
          height: 100px;
          margin: 28px auto 22px;
          background-image: url(../../assets/img/journey/loading/img-03-en.svg?url);
        }

        &.ko {
          .image {
            background-image: url(../../assets/img/journey/loading/img-03-ko.svg?url);
          }
        }

        &.ja {
          .image {
            background-image: url(../../assets/img/journey/loading/img-03-ja.svg?url);
          }
        }
      }

      &.page4 {
        .image {
          width: 270px;
          height: 100px;
          margin: 28px auto 22px;
          background-image: url(../../assets/img/journey/loading/img-04-en.svg?url);
        }

        &.ko {
          .image {
            background-image: url(../../assets/img/journey/loading/img-04-ko.svg?url);
          }
        }

        &.ja {
          .image {
            background-image: url(../../assets/img/journey/loading/img-04-ja.svg?url);
          }
        }
      }

      &.page5 {
        .title {
          margin-top: -17px;
        }

        .image {
          width: 310px;
          height: 115px;
          margin: 29px auto 22px;
          background-image: url(../../assets/img/journey/loading/img-05.jpg?url);
        }
      }

      &.page6 {
        .title {
          margin-top: -17px;
        }

        .image {
          width: 310px;
          height: 115px;
          margin: 29px auto 22px;
          background-image: url(../../assets/img/journey/loading/img-06.jpg?url);
        }
      }

      &.page7 {
        .image {
          width: 370px;
          height: 100px;
          margin: 28px auto 22px;
          background-image: url(../../assets/img/journey/loading/img-07-en.svg?url);
        }

        &.ko {
          .image {
            background-image: url(../../assets/img/journey/loading/img-07-ko.svg?url);
          }
        }

        &.ja {
          .image {
            background-image: url(../../assets/img/journey/loading/img-07-ja.svg?url);
          }
        }
      }

      &.page8 {
        .image {
          width: 420px;
          height: 198px;
          margin: 25px auto 0;
          background-image: url(../../assets/img/journey/loading/img-08.jpg?url);
        }
      }

      &.page9 {
        .title {
          margin-top: 5px;
        }

        .image {
          width: 372px;
          height: 138px;
          margin: 23px auto 20px;
          background-image: url(../../assets/img/journey/loading/img-09.jpg?url);
        }

        .text {
          width: 372px;
          margin: 0 auto 20px;
          text-align: left;

          i {
            vertical-align: middle;
            width: 88px;
            height: 14px;
          }

          p {
            display: inline-block;
            vertical-align: middle;
            margin: 2px 0 0 8px;
          }
        }
      }
    }
  }
}

@keyframes loading {
  0% {
    transform: translateX(-15px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(180px);
    opacity: 0;
  }
}
</style>
